import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUser } from '../context/UserContext';
import useSettingData from '../hooks/useSettingData';
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const decodeToken = (token) => {
    try {
        const base64Payload = token.split('.')[1];
        const payload = decodeURIComponent(
            atob(base64Payload.replace(/-/g, '+').replace(/_/g, '/'))
                .split('')
                .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
                .join('')
        );
        return JSON.parse(payload);
    } catch (error) {
        console.error('Invalid token:', error);
        return null;
    }
};
const SignInScreen = () => {
    const [showOldPassword, setShowOldPassword] = useState(false); // Track password visibility
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { setUserInfo } = useUser();
    const { systemData } = useSettingData();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage(''); // Clear previous error message
        setErrorMessage(''); // Clear previous error messages

        if (!username && !password) {
            setErrorMessage('Please enter your username and password.');
            return;
        } else if (!username) {
            setErrorMessage('Please fill in your username.');
            return;
        } else if (!password) {
            setErrorMessage('Please fill in your password.');
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/auth/signin`, { username, password });
            const {token} = response.data;
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // const decodedToken = JSON.parse(atob(token.split('.')[1]));
            const decodedToken = decodeToken(token);
            if (!decodedToken) {
                throw new Error('Failed to decode token');
            }
            const fname = decodedToken.fname;
            const lname = decodedToken.lname;
            const userId = decodedToken.id;
            const roles = decodedToken.roles;
            const slot_number = decodedToken.slot_number;
            const department_name = decodedToken.department_name;
            const department_type = decodedToken.department_type;
            const office_id = decodedToken.office_id;
            const permissions = decodedToken.permissions; // Access permissions

            const userInfo = { 
                firstName: fname,
                lastName: lname,
                userId: userId,
                roles: roles,
                slot_number: slot_number, 
                department_name: department_name, 
                department_type: department_type,
                office_id: office_id,
                permissions: permissions, // Include permissions
             };
            setUserInfo(fname, lname, userId, roles, slot_number, department_name, department_type, office_id, permissions);
            if (roles === 'admin') {
                navigate('/admin', { state: userInfo });
                window.location.reload(); // ✅ force reload
            } else if (roles === 'casher') {
                navigate('/casher', { state: userInfo });
                window.location.reload(); // ✅ force reload
            } else if (roles === 'pharmacy') {
                navigate('/pharmacy');
                window.location.reload(); // ✅ force reload
            } else if (roles === 'storeman') {
                navigate('/storeman');
                window.location.reload(); // ✅ force reload
            }
            else if (roles === 'card-room') {
                navigate('/card-room');
                window.location.reload(); // ✅ force reload
            }
            else if (roles === 'doctor') {
                navigate('/doctor');
                window.location.reload(); // ✅ force reload
            }
            else if (roles === 'labratory') {
                navigate('/labratory');
                window.location.reload(); // ✅ force reload
            }
            else if (roles === 'nurse') {
                navigate('/nurse');
                window.location.reload(); // ✅ force reload
            }

            else if (roles === 'triage') {
                navigate('/triage');
                window.location.reload(); // ✅ force reload
            }

            else if (roles === 'anesthesia') {
                navigate('/anesthesia');
                window.location.reload(); // ✅ force reload
            }
            
            else if (roles === 'imaging') {
                navigate('/imaging');
                window.location.reload(); // ✅ force reload
            }
            
            else if (roles === 'finance') {
                navigate('/finance');
                window.location.reload(); // ✅ force reload
            }
            else{
          toast.warn("Access Denied!")
            }
            
        } catch (error) {
            console.error('Login failed', error);
            setErrorMessage('Your Username or Password is Wrong! Please Contact Your Admin!');
        }
    };

    return (
        <div className="min-h-screen w-full bg-gray-100 flex items-center justify-center">
            <ToastContainer />
            <main className="w-full max-w-7xl mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center justify-center min-h-screen lg:min-h-0">
                    {/* Left side image - hidden on mobile, shown on md and up */}
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ type: "spring", stiffness: 50, duration: 0.8 }}
                        className="hidden md:flex justify-center items-center lg:w-1/2 p-4"
                    >
                        <div className="w-full max-w-md">
                            <img className="w-full h-auto object-cover" src="../assets/signin.png" alt="signin" />
                        </div>
                    </motion.div>
                    
                    {/* Right side login form - centered on all screens */}
                    <div className="w-full lg:w-1/2 flex justify-center items-center p-4">
                        <motion.div
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="w-full max-w-md"
                           >
                            <form 
                                className="bg-white w-full p-6 md:p-8 rounded-3xl shadow-lg"
                                onSubmit={handleSubmit}
                            >
                                <div className="text-center mb-6">
                                    <div className="flex justify-center mb-4">
                                        <img 
                                            src="/assets/hiywot_logo.jpg" 
                                            alt="Hospital Logo" 
                                            className="w-full h-full md:w-48 md:h-48 object-contain" 
                                        />
                                    </div>
                                </div>
                                {errorMessage && (
                                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6">
                                        <strong className="font-bold">Error:</strong>
                                        <span className="block sm:inline"> {errorMessage}</span>
                                    </div>
                                )}
                                
                                <div className="space-y-4 md:space-y-6">
                                    {/* Username field with person icon */}
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                                            <i className="fas fa-user"></i>
                                        </span>
                                        <input 
                                            className="w-full pl-10 pr-4 py-3 rounded-lg ring-blue-200 focus:ring-4 focus:outline-none transition duration-300 border border-gray-300" 
                                            type="text" 
                                            placeholder="Username"
                                            value={username} 
                                            onChange={(e) => setUsername(e.target.value)} 
                                        />
                                    </div>
                                    
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                                            <i className="fas fa-lock"></i>
                                        </span>
                                        <input 
                                            className="w-full pl-10 pr-10 py-3 rounded-lg ring-blue-200 focus:ring-4 focus:outline-none transition duration-300 border border-gray-300" 
                                            type={showOldPassword ? "text" : "password"} 
                                            placeholder="Password"
                                            value={password} 
                                            onChange={(e) => setPassword(e.target.value)} 
                                        />
                                        <span
                                            className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                            onClick={() => setShowOldPassword(!showOldPassword)}
                                        >
                                            {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                                
                                <button 
                                    className="w-full py-3 mt-6 text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-all duration-300 font-medium" 
                                    type="submit"
                                >
                                    Sign In
                                </button>
                            </form>
                        </motion.div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default SignInScreen;
